import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import LoadingComponent from '@shared/components/loading/loading.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  isLoading = true;
  private title = inject(Title);
  constructor(private _authService: AuthService) {
    _authService.login();
  }

  ngOnInit(): void {
    let projectName = environment.projectName;

    if (projectName == 'cg') {
      this.title.setTitle('CoiniGo Admin Panel');
    } else {
      this.title.setTitle('CoiniJet Admin Panel');
    }
  }

  get authenticated(): boolean {
    return this._authService.authenticated && this._authService.isPermissionsGet;
  }
}
